import Vue from 'vue'
import Router from 'vue-router'

import storeX from '@/store/index'

import home from '@/apps/home/home.vue'
import login from '@/apps/login/login.vue'
import reset from '@/apps/login/reset.vue'
import register from '@/apps/login/register.vue'

//import logout from '@/views/logout.vue'
// import profile from '@/apps/profile/profile.vue'
import catalog from '@/apps/catalog/catalog.vue'
import catalogImport from '@/apps/catalog_import/catalogImport.vue'
import account from '@/apps/account/account.vue'
import cash from '@/apps/cash/cash.vue'
import company from '@/apps/company/company.vue'
import customer from '@/apps/customer/customer.vue'
import debtor from '@/apps/debtor/debtor.vue'
import debtRepaymentForm from '@/apps/debtor/debtRepaymentForm.vue'
import moneyOrder from '@/apps/money_order/moneyOrder.vue'
import productOrder from '@/apps/product_order/productOrder.vue'
import productOrderChangeIn from '@/apps/product_order/productOrderChangeIn.vue'
import productOrderForm from '@/apps/product_order/productOrderForm.vue'
import productOrderFormChangeIn from '@/apps/product_order/productOrderFormChangeIn.vue'
import productOrderFormChangeOut from '@/apps/product_order/productOrderFormChangeOut.vue'
import productOrderFormMoving from '@/apps/product_order/productOrderFormMoving.vue'
import productOrderFormInventory from '@/apps/product_order/productOrderFormInventory.vue'
// import productOrderForm from '@/apps/product_order/productOrderForm.vue'
import report from '@/apps/report/report.vue'
import shiftReport from '@/apps/report/shiftReport.vue'
import ticketHistory from '@/apps/money_order/ticketHistory.vue'
import fiscalOperations from '@/apps/report/fiscalOperations.vue'
import productOperations from '@/apps/report/productOperations.vue'

import cashPeriodReport from '@/apps/report/cashPeriodReport.vue'
import shift from '@/apps/shift/shift.vue'
import store from '@/apps/store/store.vue'
import supplier from '@/apps/supplier/supplier.vue'
import user from '@/apps/user/user.vue'
import productOrderActions from "../apps/product_order/productOrderActions";
// import App from '@/App.vue'
import currentUser from '@/apps/user/currentUser.vue'
import iView from "iview";
import productOrderChangeOut from "../apps/product_order/productOrderChangeOut";
import productOrderMoving from "../apps/product_order/productOrderMoving";
import productOrderChangeInventory from "../apps/product_order/productOrderChangeInventory";
import moneyOrderActions from "../apps/money_order/moneyOrderActions";
import warehouse from "../apps/catalog/warehouse";

import businessGraphics from "../apps/report/businessGraphics";
import seasonality from "../apps/report/seasonality";
import productsAndService from "../apps/report/productsAndService";


import payment from "../apps/payment/payment";
import licenseKeys from "../apps/payment/licenseKeys";
import paymentHistory from "../apps/payment/paymentHistory";


import autoClosingShift from "../apps/cash/autoClosingShift";


import integrations from "../apps/integrations/integrations";
import moduleLightPos from "../apps/integrations/moduleLightPos";
import moduleLightKassa from "../apps/integrations/moduleLightKassa";
import moduleFiskal from "../apps/integrations/moduleFiskal";
import {reset_addr, server_addr} from "../http";
// import iView from 'view-design';


Vue.use(Router);

let router = new Router({

  routes: [

    {
      path: '/login',
      name: 'login',
      component: login,
    },

    {
      path: '/login/reset',
      name: 'reset',
      component: reset
    },

    {
      path: '/login/register',
      name: 'register',
      component: register,
    },


    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // {
    //   path: '/logout',
    //   name: 'logout',
    //   component: logout
    // },

    // {
    //   path: '/profile',
    //   name: 'profile',
    //   component: profile,
    //   meta: {
    //     requiresAuth: true
    //   },
    // },

    // --- CATALOG ---
    {
      path: '/catalog',
      name: 'catalog',
      component: catalog,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/catalog/detail/:id',
      name: 'catalog_detail',
      component: catalog,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/catalog/edit/:id',
      name: 'catalog_edit',
      component: catalog,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/catalog/create',
      name: 'catalog_create',
      component: catalog,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/warehouse',
      name: 'warehouse',
      component: warehouse,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    {
      path: '/warehouse/detail/:id',
      name: 'warehouse_detail',
      component: warehouse,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // --- CATALOG IMPORT ---
    {
      path: '/catalog_import',
      name: 'catalog_import',
      component: catalogImport,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // --- REPORT ---
    {
      path: '/business_graphics_report',
      name: 'business_graphics',
      component: businessGraphics,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/seasonality_report',
      name: 'seasonality',
      component: seasonality,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/products_and_service_report',
      name: 'products_and_service',
      component: productsAndService,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/period_report',
      name: 'period_report',
      component: cashPeriodReport,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    // --- CASH ---
    {
      path: '/cash',
      name: 'cash',
      component: cash,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/cash/detail/:id',
      name: 'cash_detail',
      component: cash,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/cash/edit/:id',
      name: 'cash_edit',
      component: cash,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/cash/create',
      name: 'cash_create',
      component: cash,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    {
      path: '/shift',
      name: 'shift',
      component: shift,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/shift/detail/:id',
      name: 'shift_detail',
      component: shift,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/shift/edit/:id',
      name: 'shift_edit',
      component: shift,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/shift/create',
      name: 'shift_create',
      component: shift,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    {
      path: '/company',
      name: 'company',
      component: company,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // --- CUSTOMER ---
    {
      path: '/customer',
      name: 'customer',
      component: customer,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/customer/detail/:id',
      name: 'customer_detail',
      component: customer,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/customer/edit/:id',
      name: 'customer_edit',
      component: customer,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/customer/create',
      name: 'customer_create',
      component: customer,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // --- DEBTOR ---
    {
      path: '/debtor',
      name: 'debtor',
      component: debtor,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/debtor/detail/:id',
      name: 'debtor_detail',
      component: debtor,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/debtor/edit/:id',
      name: 'debtor_edit',
      component: debtor,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/debtor/create',
      name: 'debtor_create',
      component: debtor,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/debtor/create_debt_repayment',
      name: 'debt_repayment_create',
      component: debtor,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    // --- SUPPLIER ---
    {
      path: '/supplier',
      name: 'supplier',
      component: supplier,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/supplier/detail/:id',
      name: 'supplier_detail',
      component: supplier,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/supplier/edit/:id',
      name: 'supplier_edit',
      component: supplier,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/supplier/create',
      name: 'supplier_create',
      component: supplier,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    // --- MONEY ORDER ---
    {
      path: '/mdocs',
      name: 'money_order',
      component: moneyOrder,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/mdocs/detail/:id',
      name: 'money_order_detail',
      component: moneyOrder,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/mdocs/edit/:id',
      name: 'money_order_edit',
      component: moneyOrder,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/mdocs/create',
      name: 'money_order_create',
      component: moneyOrder,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/mdocs/create_transfer',
      name: 'money_order_create_transfer',
      component: moneyOrder,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/mdoc_actions',
      name: 'mdoc_actions',
      component: moneyOrderActions,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // --- PRODUCT ORDER ---
    {
      path: '/pdocs',
      name: 'product_order',
      component: productOrder,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdoc-changes-in',
      name: 'product_order_changes_in',
      component: productOrderChangeIn,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdoc-changes-out',
      name: 'product_order_changes_out',
      component: productOrderChangeOut,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdoc-moving',
      name: 'product_order_moving',
      component: productOrderMoving,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdoc-inventory',
      name: 'product_order_changes_inventory',
      component: productOrderChangeInventory,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/detail/:id',
      name: 'product_order_detail',
      component: productOrder,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/edit/:id',
      name: 'product_order_edit',
      component: productOrderForm,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/create',
      name: 'product_order_create',
      component: productOrderForm,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/changes_in/create',
      name: 'product_order_change_in_create',
      component: productOrderFormChangeIn,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/changes_in/edit/:id',
      name: 'product_order_change_in_edit',
      component: productOrderFormChangeIn,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/changes_out/create',
      name: 'product_order_change_out_create',
      component: productOrderFormChangeOut,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/changes_out/edit/:id',
      name: 'product_order_change_out_edit',
      component: productOrderFormChangeOut,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/changes_moving/create',
      name: 'product_order_change_moving_create',
      component: productOrderFormMoving,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/changes_moving/edit/:id',
      name: 'product_order_change_moving_edit',
      component: productOrderFormMoving,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/inventory/create',
      name: 'product_order_inventory_create',
      component: productOrderFormInventory,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/pdocs/inventory/edit/:id',
      name: 'product_order_inventory_edit',
      component: productOrderFormInventory,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    {
      path: '/pdoc_actions/',
      name: 'pdoc_actions',
      component: productOrderActions,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // {
    //   path: '/report',
    //   name: 'report',
    //   component: report,
    //   meta: {
    //     requiresAuth: true
    //   },
    // },


    {
      path: '/mdocs/fiscal_operations',
      name: 'fiscal_operations',
      component: fiscalOperations,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    {
      path: '/mdocs/product_operations',
      name: 'product_operations',
      component: productOperations,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    // {
    //   path: '/mdocs/shift_report',
    //   name: 'mdoc_shift',
    //   component: shiftReport,
    //   meta: {
    //     requiresAuth: true,
    //     role_banned: 'cashier'
    //   },
    // },
    // {
    //   path: '/mdocs/ticket_history',
    //   name: 'ticket_history',
    //   component: ticketHistory,
    //   meta: {
    //     requiresAuth: true,
    //     role_banned: 'cashier'
    //   },
    // },


    // --- PAYMENT ---
    {
      path: '/payments/payment',
      name: 'payment',
      component: payment,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/payments/license_keys',
      name: 'license_keys',
      component: licenseKeys,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/payments/payment_history',
      name: 'history_payment',
      component: paymentHistory,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    // --- integrations ---
    {
      path: '/integrations',
      name: 'integrations',
      component: integrations,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/module_light_pos',
      name: 'moduleLightPos',
      component: moduleLightPos,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/module_light_kassa',
      name: 'moduleLightKassa',
      component: moduleLightKassa,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/module_fiskal',
      name: 'moduleFiskal',
      component: moduleFiskal,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    // --- STORE ---
    {
      path: '/store',
      name: 'store',
      component: store,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/store/detail/:id',
      name: 'store_detail',
      component: store,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/store/edit/:id',
      name: 'store_edit',
      component: store,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/store/create',
      name: 'store_create',
      component: store,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },


    {
      path: '/auto_closing_shift',
      name: 'auto_closing_shift',
      component: autoClosingShift,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // --- USER ---
    {
      path: '/user',
      name: 'user',
      component: user,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/user/detail/:id',
      name: 'user_detail',
      component: user,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/user/edit/:id',
      name: 'user_edit',
      component: user,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/user/create',
      name: 'user_create',
      component: user,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/current_user',
      name: 'current_user',
      component: currentUser,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },

    // --- ACCOUNT ---
    {
      path: '/account',
      name: 'account',
      component: account,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/account/detail/:id',
      name: 'account_detail',
      component: account,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/account/edit/:id',
      name: 'account_edit',
      component: account,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    },
    {
      path: '/account/create',
      name: 'account_create',
      component: account,
      meta: {
        requiresAuth: true,
        role_banned: 'cashier'
      },
    }


  ],
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();

  if (to.matched.some(record => record.meta.requiresAuth === true)) {

    if (!localStorage.getItem('access_token')) {
      next({
        name: 'login',
        params: {next: to.fullPath}
      })
    }

    else {
      next();
    }
  }

  else {
    next();
  }





});

router.afterEach((to, from) => {
  iView.LoadingBar.finish();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js